import { Preset, PresetDefinition } from './Preset.interface';
export const DEFAULT_PRESET: Preset = 'QuickQuote';

/**
 * Definition of the PRESETS available in the application.
 * We should never rely on the direct value in the features and other components.
 * For example something like if (preset === 'QQauto') is forbidden.
 * We should always use the 'abstract' capabilities that are defined below.
 */
export const PRESETS: Record<Preset, PresetDefinition> = {
    QuickQuote: {
        type: 'QuickQuote',
        // screens: {
        //     catalog: {},
        //     economicSector: {
        //         options: OPTIONS_FOR_SECTOR,
        //     },
        //     legalStatus: {
        //         options: OPTIONS_FOR_LEGAL_STATUS,
        //     },
        //     income: {
        //         display: 'dropdown',
        //     },
        // },
        stepper: {
            data: {
                'VehicleIdentificationChoice': {
                    activeStep: 0,
                    stepProgress: 10,
                },
                'LicensePlateIdentification': {
                    activeStep: 0,
                    stepProgress: 50,
                },
                'BrandIdentification': {
                    activeStep: 0,
                    stepProgress: 25,
                },
                'ModelIdentification': {
                    activeStep: 0,
                    stepProgress: 40,
                },
                'CirculationDate': {
                    activeStep: 0,
                    stepProgress: 60,
                },
                'BodyType': {
                    activeStep: 0,
                    stepProgress: 75,
                },
                'MotorizationType': {
                    activeStep: 0,
                    stepProgress: 90,
                },
                'Birthdate': {
                    activeStep: 1,
                    stepProgress: 20,
                },
                'Licence': {
                    activeStep: 1,
                    stepProgress: 40,
                },
                'BonusPenaltyCoefficient': {
                    activeStep: 1,
                    stepProgress: 60,
                },
                'InsuranceDelay': {
                    activeStep: 1,
                    stepProgress: 90,
                },
                'Contact': {
                    activeStep: 2,
                    stepProgress: 50,
                },
                'Pricing': null,
                'VehicleIdentificationLicensePlate': null,
                'VehicleIdentificationModel': null,
                'PreConfirmation': null,
                'End/Confirmation': null,
                'End/AxaPartner': null,
                'End/Reject': null,
                'End/Unreliable-contact-information': null,
                'End/Apart-from-metropolis': null,
                'End/Rejet-sec': null,
                'End/Rejet-vtc': null,
                'End/Out-of-bounds': null,
                'End/Insurance': null,
                'End/Off-target-product': null,
                'Error': null,
                'Scenarios': null,
                'RecommandationHome': null,
                'HasEmployees': null,
                'HasPeculiarities': null,
                'CumulativeValueOfGoods': null,
                'BusinessPremisesPresence': null,
                'BusinessPremisesOwnership': null,
                'BusinessPremisesSurface': null,
                'PreTarification': null,
                'Tarification': null,
            },
            steps: [
                'Votre véhicule',
                'Votre profil',
                'Vos informations',
                'Votre tarif',
                'Confirmation',
            ],
        },
    },
};

/**
 * Select the preset or fallbacks on the default value (@see DEFAULT_PRESET)
 * @param value
 * @returns
 */
export function selectPreset(value: Preset | string | undefined): PresetDefinition {
    if (!value) {
        return PRESETS[ DEFAULT_PRESET ];
    }

    return PRESETS[ value as Preset ] || PRESETS[ DEFAULT_PRESET ];
}
